/**
 * Ad-block detection.
 * Checks whether common ad elements are hidden by browser content filters.
 * Shows a dismissible banner when an ad blocker is detected.
 */
(function() {
    'use strict';

    var STORAGE_KEY = 'adblock-banner-dismissed';
    var DISMISS_DURATION_MS = 7 * 24 * 60 * 60 * 1000;
    var BAIT_CHECK_DELAY_MS = 100;

    function isDismissed() {
        try {
            var ts = localStorage.getItem(STORAGE_KEY);
            if (!ts) return false;
            return (Date.now() - parseInt(ts, 10)) < DISMISS_DURATION_MS;
        } catch (_) {
            return false;
        }
    }

    function dismiss() {
        try {
            localStorage.setItem(STORAGE_KEY, String(Date.now()));
        } catch (_) {
            // localStorage unavailable
        }
        var banner = document.getElementById('adblockBanner');
        if (banner) banner.remove();
    }

    function showBanner() {
        var banner = document.getElementById('adblockBanner');
        if (banner) {
            banner.classList.remove('hidden');
        }
    }

    function createBaitElement() {
        var bait = document.createElement('div');
        bait.className = 'adsbox ad-banner text-ad textAd pub_300x250 adsbygoogle';
        bait.setAttribute('aria-hidden', 'true');
        bait.style.position = 'absolute';
        bait.style.left = '-10000px';
        bait.style.top = '-1000px';
        bait.style.width = '1px';
        bait.style.height = '1px';
        bait.style.pointerEvents = 'none';
        bait.style.overflow = 'hidden';
        document.body.appendChild(bait);
        return bait;
    }

    function isBaitHidden(bait) {
        var style = window.getComputedStyle(bait);
        var rect = bait.getBoundingClientRect();

        return style.display === 'none' ||
            style.visibility === 'hidden' ||
            parseFloat(style.opacity) === 0 ||
            rect.width === 0 ||
            rect.height === 0;
    }

    function checkBait() {
        var bait = createBaitElement();

        setTimeout(function() {
            try {
                if (isBaitHidden(bait)) {
                    showBanner();
                }
            } finally {
                bait.remove();
            }
        }, BAIT_CHECK_DELAY_MS);
    }

    function detect() {
        if (!document.getElementById('adblockBanner')) return;
        if (isDismissed()) return;

        // Only check if AdSense was actually included on the page.
        // Without this guard, environments where ads aren't served (local dev,
        // ad-free tiers) would falsely trigger the ad-block banner.
        var adsenseScript = document.querySelector('script[src*="pagead2.googlesyndication.com"]');
        if (!adsenseScript) return;

        checkBait();
    }

    window.__adblockDismiss = dismiss;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', detect);
    } else {
        detect();
    }
})();
